import React from 'react'

import Layout from '@/components/Layout'
import SEO from '@/components/Seo'
import { Shanghai } from '@/components/Rankings'
import { Content } from '@/components/Rankings/style.css'
import { Columns } from '@/components/Article/style.css'
import Summary from '@/components/Summary'

const IndexPage = () => (
  <Layout>
    <SEO
      title="Ranking shanghai"
      keywords={[
        `La Tercera`,
        `Ranking Shanghai`,
        `Universidades Chilenas en el extranjero`,
      ]}
    />
    <Content>
      <h1>
        Ranking <strong>Shanghai</strong>
      </h1>
      <Columns>
        <p>
          El ranking Shanghai clasifica, desde 2003, a las universidades por su
          excelencia investigadora. En su última edición analizó más de dos mil
          instituciones de todo el mundo, pero solo se publicaron las mejores
          1.000. Desde 2017 son las mismas casas de estudio las que lideran el
          listado: U. de Harvard (1), Stanford (2) y Cambridge (3); mientras que
          los países que tienen un mayor número de instituciones son Estados
          Unidos (200), China (180) y Reino Unido (65).
        </p>
        <p>
          A nivel latinoamericano son cinco los países presentes: Brasil con 21
          casas de estudio, Chile (4), Argentina (3), México (2) y Colombia (2).
          La lista la lidera la U. de São Paulo en el lugar
          101-150anivelmundial.A nivel nacional, la U. de Chile se encuentra en
          la franja de 401 a 500 mejores universidades del mundo, y tras ella, a
          partir del número 501, aparecen la Católica, Andrés Bello y de
          Concepción. Como en su elaboración se incluye la existencia de
          exalumnos y académicos con premios Nobeles o Medallas Field —cosa que
          en el país solo cumple la Universidad de Chile, ya que Gabriela
          Mistral y Pablo Neruda fueron ex alumnos de la institución—, la
          apuesta de las universidades debe concentrarse en los indicadores de
          investigación. Algo en que la Andrés Bello destaca, pues cuenta con un
          investigador altamente citado, José Rodríguez.
        </p>
      </Columns>
      <Shanghai />
    </Content>
    <Summary />
  </Layout>
)

export default IndexPage
